import { observer } from 'mobx-react-lite';
import { React, useState, useEffect, useRef } from 'react';

import AppState from '../../js/AppState';
import PresentationHelper, {MODES, nodeDialConfig} from '../../js/PresentationHelper';
import {Dial} from 'react-sdk/Personnage/Dialogues'
import Board from "./Board/Board"

import './ScreenPresentation.css'
import MultipleCharacters from '../shared/CanvasCharacters/CanvasCharacters';
import CanvasCharacters from '../shared/CanvasCharacters/CanvasCharacters';
import SpeechHelper from '../../js/SpeechHelper';
import Subtitle from '../shared/Subtitle/Subtitle';

let once = true // ugly fix to the dual first dial

const ScreenPresentation = () => {
  let loaded = useRef(false)
  let openflContainer = useRef(null)
  let type = useRef(null)
  let background = useRef(null)
  let content = useRef(null)
  let content_alt_text = useRef(null)
  let isSubtitleNameOnTheRight = useRef(false)
  
  const [text, setText] = useState(null)
  const [refreshToken, setRefreshToken] = useState(0)

  
  useEffect(() => {
    loaded.current = true    
    // SpeechHelper.setTextCallback(setText)
    
    setTimeout(() => { // ugly fix to the loading delay problem
      // AppState.loaderOverlay = false
    }, 500)
  }, [])

  useEffect(() => {

    // if(AppState.sound) window.SpeechAPI.mute()
    // else window.SpeechAPI.unmute()

  }, [AppState.sound])

  useEffect(() => {
    SpeechHelper.createDialDiv(openflContainer.current).then(() => {
      window.SpeechAPI.setLogLevel(6)
      window.SpeechAPI.enableBackToNeutral(true, 0.5)
      
      SpeechHelper.loadSpeechCharacter("little-philosophers.char" , PresentationHelper.getCharacterList()).then(() => {
        SpeechHelper.prepareSpeechScene(AppState.files_root + "presentation.speechLevel", PresentationHelper.getFirstSpeaker()).then(() => {
          PresentationHelper.startPresentation()
    
          SpeechHelper.setTextCallback(setText)
          AppState.loaderOverlay = false
        })
      })
    })

  }, [openflContainer])

  useEffect(() => {
    if(PresentationHelper.currentNode === null) return;

    type.current = PresentationHelper.currentNode.type
    background.current = PresentationHelper.currentNode.background
    content.current = PresentationHelper.currentNode.content
    content_alt_text.current = PresentationHelper.currentNode.content_alt_text

    SpeechHelper.playDialogue(PresentationHelper.currentNode.dialData, handleNext)

    isSubtitleNameOnTheRight.current = PresentationHelper.isCurrentCharacterRight()

    console.log(PresentationHelper.currentNode.dialData.vue)
    console.log(PresentationHelper.currentNode.dialData.character)


    setRefreshToken(tk => tk + 1)
  }, [PresentationHelper.currentNode])

  // useEffect(() => {
    // console.log(text)
  // }, [text])

  useEffect(() => {
    if(once) { 
      once = false
      return
    }

    if(AppState.paused) {
      SpeechHelper.handlePause()
    }
    else {
      SpeechHelper.handleResume()
    }
  }, [AppState.paused])

  function clickNext(e) {
    if(e) e.stopPropagation()

    // if(AppState.paused) return

    handleNext()
  }

  function handleNext()
  {
    if(AppState.paused) return

    PresentationHelper.handleNext()
  }

  return (
    <div className='ScreenPresentation'>


      { background && <img className='background' src={background.current} onClick={(e) => clickNext(e)} /> }
      { content.current && <Board onClick={(e) => clickNext(e)} type={type.current} content={content.current} alt_text={content_alt_text.current} handleNext={(e) => clickNext(e)} /> }      
      { <CanvasCharacters className={""} onClick={(e) => clickNext(e)} />} 
      { text && AppState.subtitles_visible && <Subtitle className={""} text={ text } character={ PresentationHelper.currentNode.dialData.character } isRight={ isSubtitleNameOnTheRight.current } onClick={(e) => clickNext(e)} /> }
      { <div id="openfl-container" ref={openflContainer}></div> }
    </div>
  );
};

export default observer(ScreenPresentation)